export const SF_CONTENT = {
  hero: {
    kicker: 'Para empresas com equipe de vendedores externos',
    title: 'Sua força de vendas trabalha espalhada, e você só sabe o resultado no fim do mês.',
    subtitle:
      'Dê ao seu time uma carteira de clientes organizada, proposta em PDF pronta para o atendimento e comissão automática — e tenha visibilidade de cada vendedor, em tempo real, sem depender de planilha.',
    cta: 'Quero organizar minha força de vendas',
    ctaMessage: 'Quero conhecer o sistema para força de vendas do 77Gestão',
    urgency: 'Enquanto cada vendedor trabalha do seu jeito, você não sabe quem está performando e quem está parado.',
  },

  statsStrip: [
    { number: '1 painel', label: 'para acompanhar todo o time de vendas', icon: 'fa-solid fa-people-arrows' },
    { number: 'Automático', label: 'cálculo de comissão por vendedor', icon: 'fa-solid fa-calculator' },
    { number: 'Zero', label: 'disputa de cliente entre vendedores', icon: 'fa-solid fa-user-lock' },
  ],

  pain: {
    title: 'Reconhece esses gargalos na sua equipe de vendas externa?',
    intro:
      'Quem gerencia uma força de vendas sabe: sem sistema, cada vendedor vira uma ilha e o gestor só descobre o resultado quando já é tarde para agir.',
    items: [
      { icon: 'fa-solid fa-eye-slash', text: 'Você não sabe, no meio do mês, quanto cada vendedor já vendeu e quem está performando abaixo do esperado.' },
      { icon: 'fa-solid fa-users-rectangle', text: 'Mais de um vendedor disputa o mesmo cliente porque a carteira não é organizada dentro de um sistema.' },
      { icon: 'fa-solid fa-table-cells', text: 'Comissão de toda a equipe calculada manualmente em planilha, com erro e atraso todo fim de mês.' },
      { icon: 'fa-solid fa-file-circle-exclamation', text: 'Cada vendedor faz orçamento do seu próprio jeito, sem padrão, sem PDF profissional para o cliente.' },
      { icon: 'fa-solid fa-route', text: 'Você não sabe qual canal de vendas (indicação, prospecção, loja) traz mais resultado para o time.' },
    ],
  },

  midCta: {
    text: 'E se você pudesse ver o resultado de cada vendedor da sua força de vendas em tempo real, sem esperar o fim do mês?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do sistema para força de vendas do 77Gestão',
  },

  solution: {
    title: 'Sua equipe de vendas organizada, com visibilidade de gestor.',
    intro:
      'O 77Gestão dá a cada vendedor sua própria carteira e ferramenta de trabalho, e a você, gestor, a visão do time inteiro em um só lugar.',
    cards: [
      {
        icon: 'fa-solid fa-user-lock',
        title: 'Carteira de clientes restrita por vendedor',
        text: 'Cada vendedor vê e negocia apenas com os clientes vinculados a ele, sem disputa com o resto da equipe.',
      },
      {
        icon: 'fa-solid fa-calculator',
        title: 'Comissão automática por vendedor',
        text: 'A comissão de cada vendedor é calculada a partir de cada venda fechada — sem planilha, sem conferência manual no fim do mês.',
      },
      {
        icon: 'fa-solid fa-chart-line',
        title: 'Relatório de performance por vendedor',
        text: 'Acompanhe quanto cada vendedor vendeu, sua comissão gerada e sua evolução, tudo em um único painel de gestão.',
      },
      {
        icon: 'fa-solid fa-file-pdf',
        title: 'Proposta em PDF padronizada para o time todo',
        text: 'Todo vendedor gera proposta comercial no mesmo padrão profissional, direto no atendimento, sem depender de modelo solto.',
      },
      {
        icon: 'fa-solid fa-route',
        title: 'Canais de negociação por vendedor',
        text: 'Saiba de onde vêm as vendas de cada vendedor — indicação, prospecção própria, loja física ou outro canal.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando o gestor para de depender da planilha para enxergar o time',
    intro:
      'Uma empresa com 6 vendedores externos só sabia o resultado de cada um quando o financeiro fechava a comissão do mês — e nesse momento já era tarde para corrigir o rumo.',
    stats: [
      { number: 'Tempo real', label: 'visibilidade do resultado de cada vendedor' },
      { number: '0', label: 'disputas de carteira entre vendedores' },
      { number: 'Automático', label: 'cálculo de comissão de toda a equipe' },
    ],
    paragraphs: [
      'Depois de organizar a força de vendas no sistema, o gestor passou a acompanhar o resultado de cada vendedor sem esperar o fechamento do mês.',
      'A carteira restrita por vendedor acabou com a disputa de clientes entre a equipe, e a comissão passou a ser calculada automaticamente a cada venda.',
    ],
    highlight: 'Resultado: gestão do time em tempo real, sem disputa de carteira e sem planilha de comissão.',
    cta: 'Quero esse controle no meu time',
    ctaMessage: 'Vi o resultado e quero organizar a força de vendas da minha empresa no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares da gestão de uma força de vendas organizada',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade do time',
        text: 'Painel único com o resultado de cada vendedor, sem esperar o fechamento do mês para agir.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle de carteira',
        text: 'Cada vendedor com sua carteira restrita, sem disputa de cliente dentro da própria equipe.',
      },
      {
        icon: 'fa-solid fa-scale-balanced',
        title: 'Comissão sem conflito',
        text: 'Cálculo automático e igual para todo o time, sem discussão sobre valor ou atraso no pagamento.',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas com força de vendas escolhem o 77Gestão',
    items: [
      { icon: 'fa-solid fa-people-group', text: 'Funciona para times pequenos ou com dezenas de vendedores externos, todos no mesmo sistema.' },
      { icon: 'fa-solid fa-link', text: 'Carteira, proposta, comissão e canal de negociação integrados — um lançamento alimenta tudo.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada: sua equipe já começa a usar com as carteiras organizadas no sistema.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e bem avaliado, para o gestor e para cada vendedor do time.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'Isso é um CRM com automação de marketing?',
        answer:
          'Não. O 77Gestão organiza carteira de clientes, propostas, vendas e comissão da sua força de vendas — não faz automação de marketing ou captação de leads.',
      },
      {
        question: 'Cada vendedor vê os clientes dos outros vendedores da equipe?',
        answer:
          'Não. A carteira de clientes é restrita por vendedor — cada um vê e negocia apenas com os clientes vinculados a ele dentro do sistema.',
      },
      {
        question: 'Como o gestor acompanha o resultado de cada vendedor?',
        answer:
          'Pelo relatório de performance por vendedor, que mostra o total vendido e a comissão gerada por cada um, sem depender do fechamento mensal do financeiro.',
      },
      {
        question: 'A comissão é calculada igual para todos os vendedores?',
        answer:
          'A comissão é calculada automaticamente a partir de cada venda fechada, seguindo as regras configuradas por vendedor — sem cálculo manual em planilha.',
      },
      {
        question: 'Funciona para uma equipe pequena, com só 2 ou 3 vendedores externos?',
        answer:
          'Sim. O sistema se adapta tanto a uma equipe enxuta quanto a uma força de vendas maior, com o mesmo controle de carteira e comissão para todos.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de gerenciar sua força de vendas no escuro. Veja o resultado do time em tempo real.',
    subtitle:
      'Agende uma demonstração e veja, na prática, como organizar carteira, proposta e comissão de toda a sua equipe de vendas externa.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema para força de vendas do 77Gestão',
  },

  seo: {
    title: 'Sistema para Força de Vendas Externa | 77Gestão',
    description:
      'Sistema para força de vendas: carteira restrita por vendedor, proposta em PDF, comissão automática e relatório de performance de toda a equipe. Agende uma demonstração.',
  },
};
